import React from 'react';
import styles from './FieldRow.module.css';

export default function FieldRow({
	children,
	label = '',
	labelWidth = 'm',
	labelAlign = 'middle'
}) {

	const col_label_styles = [styles.col_label];
	const col_field_styles = [styles.col_field];

	col_label_styles.push(styles['align_'+labelAlign]);
	

	if (labelWidth === 'full') {
		col_label_styles.push(styles['is_full']);
		col_field_styles.push(styles['is_fix']);
	} else {
		col_label_styles.push(styles['width_'+labelWidth]);
		col_label_styles.push(styles['is_fix']);
		col_field_styles.push(styles['is_full']);
	}

	return (
		<div className={styles.row}>
			<div className={col_label_styles.join(' ')}>
				<label className={styles.label}>{label}</label>
			</div>
			<div className={col_field_styles.join(' ')}>
				{children}
			</div>
		</div>
	);
}
